import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import toast from 'react-hot-toast'
import OTPVerification from '../OTPVerification'
import { savePromoToBackend } from '../../api/promoClient'
import { useState } from 'react'

export default function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(false)
  const { verifyOTP, sendOTP, user } = useAuth()
  const navigate = useNavigate()
  
  const email = searchParams.get('email') || ''

  const handleSubmit = async (otp: string) => {
    setLoading(true)
    try {
      const result = await verifyOTP(email, otp)
      
      if (result.success) {
        const promoStr = localStorage.getItem('appliedPromo')
        if (promoStr && user) {
          try {
            const promoData = JSON.parse(promoStr)
            const userId = user._id || user.id
            if (userId) {
              await savePromoToBackend(userId, promoData)
              localStorage.removeItem('appliedPromo')
              console.log('✅ Promo saved after verification')
            }
          } catch (e) { console.error('Promo save failed:', e) }
        }
        
        toast.success('Email verified!')
        navigate('/plan-selection', { state: { email } })
      } else {
        toast.error(result.message || 'Invalid code')
      }
    } catch (error: any) {
      toast.error(error.message || 'Verification failed')
    } finally {
      setLoading(false)
    }
  }

  const handleResend = async () => { await sendOTP(email) }
  const handleBack = () => navigate('/signup')

  if (!email) {
    navigate('/signup')
    return null
  }

  return (
    <OTPVerification
      email={email}
      loading={loading}
      onSubmit={handleSubmit}
      onResend={handleResend}
      onBack={handleBack}
    />
  )
}